import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4574520d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "catalogBuildStatus",
  class: "bg-white rounded shadow ps-3 pe-1 py-2",
  ref: "catalogBuildStatus"
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "refresh", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "body" }
const _hoisted_8 = {
  key: 1,
  class: "fs-6 mb-0"
}
const _hoisted_9 = {
  key: 2,
  class: "d-flex align-items-center"
}
const _hoisted_10 = {
  key: 0,
  class: "fs-7 mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_spinner = _resolveComponent("base-spinner")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#messageContainer" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("h6", _hoisted_3, _toDisplayString(`${_ctx.$t('catalogBuildStatus')} (op ${_ctx.lastRetrievedTimeStamp})`), 1),
        (_ctx.isReady)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reloadContent && _ctx.reloadContent(...args))),
                class: "btn btn-icon btn-sm btn-link text-primary text-decoration-none"
              }, _hoisted_6)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (!_ctx.isReady)
          ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
          : (_ctx.exceptions.length > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t('errorContentCouldNotBeLoaded')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge fs-6 me-2", _ctx.buildStatusClass])
                }, _toDisplayString(_ctx.catalogusBuildStatus.status.description), 3),
                (_ctx.showEndedOn)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(`(${_ctx.$t('endedOn').toLowerCase()} ${_ctx.buildStatusTimeStamp})`), 1))
                  : _createCommentVNode("", true)
              ])),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.syncCatalog && _ctx.syncCatalog(...args))),
          class: "btn btn-sm btn-link text-primary"
        }, _toDisplayString(_ctx.$t('catalogBuild')), 1)
      ])
    ], 512)
  ]))
}